import { AbstractEntityService } from "./AbstractEntityService";
import { restService } from "./RestService";

export class TennisCourtReservationService extends AbstractEntityService {
    constructor(baseUrl) {
        super();
        this.baseUrl = baseUrl;
    }

    // GET /api/properties/{propertyId}/tennisCourtReservations?from=&to=
    async findAll(propertyId, { from, to } = {}) {
        const params = new URLSearchParams();
        if (from) params.set("from", from);
        if (to) params.set("to", to);
        const query = params.toString();
        const url = `${this.baseUrl}/properties/${propertyId}/tennisCourtReservations${query ? `?${query}` : ""}`;
        try {
            return await super.find(url);
        } catch (error) {
            this.handleError(error, "Unable to load tennis court reservations");
        }
    }

    // POST /api/properties/{propertyId}/tennisCourtReservations
    async create(propertyId, reservation) {
        const url = `${this.baseUrl}/properties/${propertyId}/tennisCourtReservations`;
        try {
            // Avoid AbstractEntityService date rewriting for HH:mm fields — post raw JSON
            return await restService.post(url, reservation);
        } catch (error) {
            this.handleError(error, "Unable to create tennis court reservation");
        }
    }
}
